/**
 * V3 — AuthCallback. Détecte le session_id dans le fragment URL,
 * l'échange via le backend, et redirige vers le dashboard.
 */
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { authSession } from './api';
import { useV3Auth } from './auth';

export default function V3AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useV3Auth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || '';
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate('/v3/login', { replace: true });
      return;
    }
    const sid = decodeURIComponent(m[1]);

    (async () => {
      try {
        const res = await authSession(sid);
        setUser(res.user);
        // Nettoyer le fragment
        window.history.replaceState(null, '', '/v3/dashboard');
        navigate('/v3/dashboard', { replace: true, state: { user: res.user } });
      } catch (e) {
        const msg = e?.response?.data?.detail || e?.message || 'Erreur d\'authentification';
        setError(msg);
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="v3-login-shell">
      {error ? (
        <div className="v3-login-card">
          <h2 style={{ color: '#ef4444' }}>Connexion refusée</h2>
          <p style={{ color: '#94a3b8', marginTop: 12 }}>{error}</p>
          <button
            onClick={() => navigate('/v3/login', { replace: true })}
            className="v3-google-btn"
            style={{ marginTop: 16 }}
          >
            Retour
          </button>
        </div>
      ) : (
        <>
          <div className="v3-loading-spinner"></div>
          <p style={{ color: '#94a3b8', marginTop: 20 }}>Connexion en cours…</p>
        </>
      )}
    </div>
  );
}
